<template>
    <div class="main-wrapper home-nine">
        <navbarnine></navbarnine>

            <indexninehome />

            <indexnineFeatured />

            <indexninechoose />

            <indexnineholiday />

            <indexninecategory />

            <indexninecounter />

            <indexnineservices />

            <indexninelocation />

            <indexninetestimonial />

            <indexninearticles />

            <indexninefooter />

            <scroll />

    </div>
</template>